module.exports = __webpack_public_path__ + "img/gaia48-1.54366367.png";